import { render } from "./PropertyAgeEditing.vue?vue&type=template&id=2d6f5e53&ts=true"
import script from "./PropertyAgeEditing.vue?vue&type=script&lang=ts"
export * from "./PropertyAgeEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__